// @need-translate
import {AgeGrade, Maybe} from '../graphql/generated/types';
import {AGE_GRADE_TO_NUMBER_MAP} from './constant';
import {t} from './getTranslations';

export function getAgeGradeText(
  ageGrade: Maybe<AgeGrade>,
  appendSuffix?: string
) {
  if (!ageGrade || ageGrade === AgeGrade.All) {
    return `${t('comment_all_tabtitle')}${appendSuffix ? appendSuffix : ''}`;
  }
  return `${AGE_GRADE_TO_NUMBER_MAP[ageGrade]}세${
    appendSuffix ? appendSuffix : ''
  }`;
}
